/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { boothOptionTemplateControllerCreateV1 } from '../fn/booth-option-template/booth-option-template-controller-create-v-1';
import { BoothOptionTemplateControllerCreateV1$Params } from '../fn/booth-option-template/booth-option-template-controller-create-v-1';
import { boothOptionTemplateControllerDeleteV1 } from '../fn/booth-option-template/booth-option-template-controller-delete-v-1';
import { BoothOptionTemplateControllerDeleteV1$Params } from '../fn/booth-option-template/booth-option-template-controller-delete-v-1';
import { boothOptionTemplateControllerFindAllV1 } from '../fn/booth-option-template/booth-option-template-controller-find-all-v-1';
import { BoothOptionTemplateControllerFindAllV1$Params } from '../fn/booth-option-template/booth-option-template-controller-find-all-v-1';
import { boothOptionTemplateControllerFindByEventIdV1 } from '../fn/booth-option-template/booth-option-template-controller-find-by-event-id-v-1';
import { BoothOptionTemplateControllerFindByEventIdV1$Params } from '../fn/booth-option-template/booth-option-template-controller-find-by-event-id-v-1';
import { boothOptionTemplateControllerFindByIdV1 } from '../fn/booth-option-template/booth-option-template-controller-find-by-id-v-1';
import { BoothOptionTemplateControllerFindByIdV1$Params } from '../fn/booth-option-template/booth-option-template-controller-find-by-id-v-1';
import { boothOptionTemplateControllerReorderV1 } from '../fn/booth-option-template/booth-option-template-controller-reorder-v-1';
import { BoothOptionTemplateControllerReorderV1$Params } from '../fn/booth-option-template/booth-option-template-controller-reorder-v-1';
import { boothOptionTemplateControllerSearchV1 } from '../fn/booth-option-template/booth-option-template-controller-search-v-1';
import { BoothOptionTemplateControllerSearchV1$Params } from '../fn/booth-option-template/booth-option-template-controller-search-v-1';
import { boothOptionTemplateControllerToggleActiveV1 } from '../fn/booth-option-template/booth-option-template-controller-toggle-active-v-1';
import { BoothOptionTemplateControllerToggleActiveV1$Params } from '../fn/booth-option-template/booth-option-template-controller-toggle-active-v-1';
import { boothOptionTemplateControllerUpdateV1 } from '../fn/booth-option-template/booth-option-template-controller-update-v-1';
import { BoothOptionTemplateControllerUpdateV1$Params } from '../fn/booth-option-template/booth-option-template-controller-update-v-1';
import { BoothOptionTemplateDto } from '../models/booth-option-template-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class BoothOptionTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `boothOptionTemplateControllerSearchV1()` */
  static readonly BoothOptionTemplateControllerSearchV1Path = '/api/v1/booth-option-template/search';

  /**
   * 부스 옵션 템플릿 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerSearchV1$Response(params?: BoothOptionTemplateControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BoothOptionTemplateDto>;
}>> {
    return boothOptionTemplateControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerSearchV1(params?: BoothOptionTemplateControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<BoothOptionTemplateDto>;
}> {
    return this.boothOptionTemplateControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BoothOptionTemplateDto>;
}>): OffsetPaginationDto & {
'items'?: Array<BoothOptionTemplateDto>;
} => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerFindAllV1()` */
  static readonly BoothOptionTemplateControllerFindAllV1Path = '/api/v1/booth-option-template';

  /**
   * 모든 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindAllV1$Response(params?: BoothOptionTemplateControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothOptionTemplateDto>>> {
    return boothOptionTemplateControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindAllV1(params?: BoothOptionTemplateControllerFindAllV1$Params, context?: HttpContext): Observable<Array<BoothOptionTemplateDto>> {
    return this.boothOptionTemplateControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BoothOptionTemplateDto>>): Array<BoothOptionTemplateDto> => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerCreateV1()` */
  static readonly BoothOptionTemplateControllerCreateV1Path = '/api/v1/booth-option-template';

  /**
   * 부스 옵션 템플릿 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerCreateV1$Response(params: BoothOptionTemplateControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
    return boothOptionTemplateControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerCreateV1(params: BoothOptionTemplateControllerCreateV1$Params, context?: HttpContext): Observable<BoothOptionTemplateDto> {
    return this.boothOptionTemplateControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothOptionTemplateDto>): BoothOptionTemplateDto => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerFindByEventIdV1()` */
  static readonly BoothOptionTemplateControllerFindByEventIdV1Path = '/api/v1/booth-option-template/event/{eventId}';

  /**
   * 행사별 활성화된 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerFindByEventIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindByEventIdV1$Response(params: BoothOptionTemplateControllerFindByEventIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothOptionTemplateDto>>> {
    return boothOptionTemplateControllerFindByEventIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 행사별 활성화된 부스 옵션 템플릿 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerFindByEventIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindByEventIdV1(params: BoothOptionTemplateControllerFindByEventIdV1$Params, context?: HttpContext): Observable<Array<BoothOptionTemplateDto>> {
    return this.boothOptionTemplateControllerFindByEventIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BoothOptionTemplateDto>>): Array<BoothOptionTemplateDto> => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerFindByIdV1()` */
  static readonly BoothOptionTemplateControllerFindByIdV1Path = '/api/v1/booth-option-template/{id}';

  /**
   * 부스 옵션 템플릿 ID로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindByIdV1$Response(params: BoothOptionTemplateControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
    return boothOptionTemplateControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 ID로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerFindByIdV1(params: BoothOptionTemplateControllerFindByIdV1$Params, context?: HttpContext): Observable<BoothOptionTemplateDto> {
    return this.boothOptionTemplateControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothOptionTemplateDto>): BoothOptionTemplateDto => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerDeleteV1()` */
  static readonly BoothOptionTemplateControllerDeleteV1Path = '/api/v1/booth-option-template/{id}';

  /**
   * 부스 옵션 템플릿 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerDeleteV1$Response(params: BoothOptionTemplateControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return boothOptionTemplateControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerDeleteV1(params: BoothOptionTemplateControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.boothOptionTemplateControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerUpdateV1()` */
  static readonly BoothOptionTemplateControllerUpdateV1Path = '/api/v1/booth-option-template/{id}';

  /**
   * 부스 옵션 템플릿 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerUpdateV1$Response(params: BoothOptionTemplateControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
    return boothOptionTemplateControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerUpdateV1(params: BoothOptionTemplateControllerUpdateV1$Params, context?: HttpContext): Observable<BoothOptionTemplateDto> {
    return this.boothOptionTemplateControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothOptionTemplateDto>): BoothOptionTemplateDto => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerReorderV1()` */
  static readonly BoothOptionTemplateControllerReorderV1Path = '/api/v1/booth-option-template/reorder';

  /**
   * 템플릿 순서 변경.
   *
   * 템플릿의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerReorderV1$Response(params: BoothOptionTemplateControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
    return boothOptionTemplateControllerReorderV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 템플릿 순서 변경.
   *
   * 템플릿의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  boothOptionTemplateControllerReorderV1(params: BoothOptionTemplateControllerReorderV1$Params, context?: HttpContext): Observable<BoothOptionTemplateDto> {
    return this.boothOptionTemplateControllerReorderV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BoothOptionTemplateDto>): BoothOptionTemplateDto => r.body)
    );
  }

  /** Path part for operation `boothOptionTemplateControllerToggleActiveV1()` */
  static readonly BoothOptionTemplateControllerToggleActiveV1Path = '/api/v1/booth-option-template/{id}/toggle-active';

  /**
   * 부스 옵션 템플릿 활성화/비활성화.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `boothOptionTemplateControllerToggleActiveV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerToggleActiveV1$Response(params: BoothOptionTemplateControllerToggleActiveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return boothOptionTemplateControllerToggleActiveV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 부스 옵션 템플릿 활성화/비활성화.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `boothOptionTemplateControllerToggleActiveV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  boothOptionTemplateControllerToggleActiveV1(params: BoothOptionTemplateControllerToggleActiveV1$Params, context?: HttpContext): Observable<boolean> {
    return this.boothOptionTemplateControllerToggleActiveV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
